import { Image, Link } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useBrandingLogo } from 'features/users/storages';

const appTitle = String(import.meta.env.VITE_APP_TITLE);

const AppLogo = () => {
  const { src, srcSet } = useBrandingLogo();

  return (
    <Link className="app-layout-logo" to="/">
      <Image alt={appTitle} className="app-layout-logo__image" preview={false} sizes="10vw" src={src} srcSet={srcSet} />
    </Link>
  );
};

export default AppLogo;
